import type { Control, FieldValues, Path } from 'react-hook-form';
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormMessage,
} from '@/components/ui/form';
import { Switch } from '@/components/ui/switch';

const ACTIVE_LABEL = 'Active';

interface FormStatusFieldProps<TValues extends FieldValues> {
  control: Control<TValues>;
  name: Path<TValues>;
  description?: string | undefined;
}

export function FormStatusField<TValues extends FieldValues>({
  control,
  name,
  description,
}: FormStatusFieldProps<TValues>) {
  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem className="flex-row items-center justify-between gap-4 rounded-xl bg-primary/3 px-3.5 py-3 ring-1 ring-primary/8">
          <div className="flex flex-col gap-1">
            <span className="text-sm leading-none font-medium">{ACTIVE_LABEL}</span>
            {description === undefined ? null : <FormDescription>{description}</FormDescription>}
            <FormMessage />
          </div>
          <FormControl>
            <Switch
              aria-label={ACTIVE_LABEL}
              checked={field.value}
              onCheckedChange={(checked) => field.onChange(checked)}
            />
          </FormControl>
        </FormItem>
      )}
    />
  );
}
